<template>
  <div class="video-end ">
    <div class="end-mask"></div>
    <div class="video-end-wrap">
      <img src="./assets/trophy.svg" alt="" />
      <div class="finished-tips">
        恭喜你完成学习！
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class VideoEnd extends Vue {
  @Prop({ type: Object, default: () => {} }) content!: Content & {
    isFinished: boolean;
  };

  handleReturn() {
    this.$PostConnection?.command('redirect_course');
  }

  mounted() {
    this.$emit('changeTitleVisible', true);
    if (this.content.isFinished) return;

    // 只在第一次完课时发送完课记录，用于重新进入课程时判断当前课程是否完课
    window.storyteller.updateAssignContent({
      $id: this.content.$id,
      $kind: this.content.$kind,
      ...{
        isFinished: true
      }
    });
    // 主动上报完课(晚于常规埋点)
    setTimeout(() => {
      window.$tracker?.tracker?.pageFinish({ resource_id: this.content.$id });
    }, 0);
  }
}
</script>

<style lang="scss" scoped>
.video-end {
  @apply absolute left-0 top-0 w-full h-full flex flex-col items-center justify-center;
  z-index: 11;
  color: #fff;
  .end-mask {
    @apply absolute left-0 top-0 w-full h-full;
    z-index: -1;
    background: rgba(11, 12, 19, 0.3);
    backdrop-filter: blur(10px);
  }
  .video-end-wrap {
    @apply flex flex-col justify-center items-center;
    margin-top: -70px;
    img {
      width: 180px;
      height: 180px;
    }
  }
  .finished-tips {
    margin-top: 28px;
    font-weight: 500;
    font-size: 20px;
    line-height: 21px;
  }
  .goback-btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 240px;
    height: 43px;
    margin-top: 32px;
    line-height: 20px;
    background: linear-gradient(95.22deg, #524eff 6.46%, #8b8eff 91.58%);
    border-radius: 8px;
    cursor: pointer;
    &:hover,
    &:active {
      opacity: 0.85;
      transition: opacity 0.2s;
    }
  }
}
</style>
